import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchEmployees, ROLE_LABELS } from '../../services/employees';
import ImpersonatedApp, { homeFor, useImpersonateFetch } from './impersonation';

// Full-screen, read-only "view as [person]" — their actual desktop (their sidebar,
// their dashboard) loaded with THEIR data. Reached from the Exec Overview PM rows.
// Impersonation is enforced read-only + owner/Executive on the server.
export default function ViewAsUser() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [person, setPerson] = useState(null);
  const [ready, setReady] = useState(false);
  // Start null so the name lookup below runs as the real (Executive) user, not
  // impersonated. We flip it to the target id only once we're ready to render
  // their dashboard, so the inner app's calls carry the impersonation header.
  const idRef = useRef(null);
  useImpersonateFetch(idRef);

  useEffect(() => {
    idRef.current = null;
    setReady(false); setPerson(null);
    let alive = true;
    fetchEmployees()
      .then(list => {
        if (!alive) return;
        const u = (Array.isArray(list) ? list : []).find(x => String(x.id) === String(userId));
        if (u) setPerson(u);
        idRef.current = String(userId); // impersonate the inner app from here on
        setReady(true);
      })
      .catch(() => { if (alive) { idRef.current = String(userId); setReady(true); } });
    return () => { alive = false; };
  }, [userId]);

  // All Exec-dashboard rows are PMs, so default to that role if the name lookup
  // didn't return a record (the dashboard still loads with their data).
  const role = person ? person.role : 'ProjectManager';
  const name = person ? `${person.firstName} ${person.lastName}`.trim() : 'this teammate';
  const roleLabel = person ? (ROLE_LABELS[person.role] || person.role) : '';

  return (
    <div style={{ position: 'fixed', inset: 0, display: 'flex', flexDirection: 'column', background: '#f7f7f7', zIndex: 50 }}>
      <div style={{ flexShrink: 0, background: '#1e293b', color: '#fff', display: 'flex', alignItems: 'center', gap: 12, padding: '10px 18px' }}>
        <span style={{ fontSize: 14, fontWeight: 700 }}>👁 Viewing {name}&rsquo;s dashboard{roleLabel ? ` · ${roleLabel}` : ''}</span>
        <span style={{ fontSize: 12, fontWeight: 600, background: '#334155', padding: '2px 10px', borderRadius: 20 }}>Read-only</span>
        <div style={{ flex: 1 }} />
        <button onClick={() => navigate('/admin')} style={{ background: '#e87722', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>✕ Exit</button>
      </div>
      <div style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
        {ready ? (
          <ImpersonatedApp role={role} startPath={homeFor(role)} />
        ) : (
          <div style={{ padding: 40, color: '#6b7280', fontSize: 15 }}>Loading…</div>
        )}
      </div>
    </div>
  );
}
